/**
 * remove-actors - helper functions to delete actors from a world by reference or UUID.
 * removeActors forwards actors to the world's removal API; removeActorsByUuids searches
 * by id before delegating to the same removal logic.
 */
import type { Actor } from '../actors/Actor.js';
import type { World } from '../game/World.js';


export function removeActors(args: {
  world: World;
  actors: Actor[];
}): void {
  args.world.removeActors(...args.actors);
}

export function removeActorsByUuids(args: {
  world: World;
  actorIds: string[];
}): void {
  const actorIdsSet = new Set(args.actorIds);
  const actors = args.world.getActorsByPredicate(actor => actorIdsSet.has(actor.uuid));
  removeActors({ world: args.world, actors });
}
